export const monthDiff = (d1: Date, d2: Date) => {
    if (!d1 || !d2) {
        return null;
    }

    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
};
